/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_AboutInputs */

const en_settings_about = /** @type {(inputs: Settings_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About`)
};

const de_settings_about = /** @type {(inputs: Settings_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über Dishly`)
};

/**
* | output |
* | --- |
* | "About" |
*
* @param {Settings_AboutInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const settings_about = /** @type {((inputs?: Settings_AboutInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_AboutInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_about(inputs)
	return en_settings_about(inputs)
});